// Formatter une date
export const formatDate = (dateString, includeTime = false) => {
    if (!dateString) return '-';
    
    const date = new Date(dateString);
    
    // Vérifier si la date est valide
    if (isNaN(date.getTime())) return '-';
    
    // Formatter la date
    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    };
    
    // Ajouter l'heure si demandé
    if (includeTime) {
      options.hour = '2-digit';
      options.minute = '2-digit';
    }
    
    return date.toLocaleDateString('fr-FR', options);
  };
  
  // Formatter un montant en FCFA
  export const formatAmount = (amount) => {
    if (amount === null || amount === undefined) return '-';
    
    return new Intl.NumberFormat('fr-FR', {
      style: 'decimal',
      maximumFractionDigits: 0
    }).format(amount);
  };